import React from "react";

import { Theme, useTheme } from "@mui/material/styles";
import { Container } from "@mui/material";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";

import Grid from "@mui/material/Grid";

import Menu from "./Menu";
import NotificationBell from "../../components/notifications/NotificationBell";

const LOGO_DARK = "/logo.png";
// const LOGO_LIGHT = "/logo_allwhite.png";
const LOGO_LIGHT = LOGO_DARK;

const AppTopo = () => {
	///
	/// AppContexto
	///
	// const appContexto: AppContexto = React.useContext(ReactContext);
	const appTema: Theme = useTheme();

	///
	/// Eventos
	///

	///
	/// useEffects
	///
	React.useEffect(() => {
		// User verification handled by Auth0
	}, []);

	let strLogoURL = appTema.palette.mode === "dark" ? LOGO_DARK : LOGO_LIGHT;
	return (
		<AppBar
			position="relative"
			color="primary"
			sx={{
				height: "60px",
				maxHeight: "60px",
				backgroundColor: "#fff",
				"& > *": {
					height: "100%",
				},
				padding: appTema.spacing(0),
			}}
			style={{ zIndex: appTema.zIndex.drawer + 2 }}
		>
			<Container>
				<Toolbar disableGutters={true}>
					<Grid container spacing={1} alignItems="center">
						<Grid item xs={6} sm={4}>
							<a
								href="https://www.arteh.com.au"
								target="_blank"
								rel="noreferrer"
							>
								<img
									src={strLogoURL}
									alt="ARTEH CLIMATE PATHWAY ASSESSMENT"
									style={{ maxHeight: "44px" }}
								/>
							</a>
						</Grid>
						<Grid
							item
							xs={6}
							sm={8}
							display="flex"
							justifyContent="flex-end"
							alignItems="center"
						>
							<NotificationBell />
							<Menu />
						</Grid>
					</Grid>
				</Toolbar>
			</Container>
		</AppBar>
	);
};

export default AppTopo;
